module.exports = __webpack_public_path__ + "static/media/Dobby 3.675caa9a.jpg";